export const LogoImgDefault = (type) => {
    let image;
    const datas = [];
    if (type === 'icon') {
        try {
            image = require('../assets/images/attractions/default/icon/no-image.webp');
            return image;
        } catch (e) {
            console.log(e);
        }
    }
    if (type === 'img') {
        try {
            image = require('../assets/images/attractions/default/img/walt-disney-1923.gif');
            for (let i = 0; i < 6; i++) datas.push(image);
            return datas;
        } catch (e) {
            console.log(e);
        }
    }
}